<template>
  <button :id="id" :aria-label="ariaLabel" :class="['app-carousel-nav-button', `btn-${type}`]" type="button" />
</template>

<script>
export default {
  name: 'AppCarouselNavButton',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (val) => val === 'prev' || val === 'next',
    },
  },
  computed: {
    ariaLabel() {
      return this.type === 'prev' ? 'Previous slide' : 'Next slide';
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-carousel-nav-button {
  display: none;
  position: absolute;
  top: 0;
  z-index: 2;
  width: var(--app-carousel-nav-btn-size);
  height: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: transparent;

  @media (min-width: vars.$desktop-xl-1200-break-point) {
    display: block;
  }

  &:after {
    content: '';
    position: absolute;
    top: 40%;
    left: 50%;
    width: 30px;
    height: 30px;
    transition: all 0.2s;
    border-color: vars.$c-dark-gray;
    border-style: solid;
    border-width: 3px 3px 0 0;
  }

  &:hover {
    &:after {
      opacity: 0.6;
    }
  }

  &.btn-prev {
    right: auto;
    left: 3%;

    &:after {
      transform: translate(-50%, -50%) rotate(-135deg);
    }
  }

  &.btn-next {
    left: auto;
    right: 3%;

    &:after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  .btn-icon {
    width: 100%;
    height: 100%;
    transition: all 0.2s;
  }

  &:hover,
  &:focus {
    .btn-icon {
      opacity: 0.6;
    }
  }
}
</style>
